import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=1d688ed5&scoped=true"
import script from "./AuthFooter.vue?vue&type=script&lang=js"
export * from "./AuthFooter.vue?vue&type=script&lang=js"
import style0 from "./AuthFooter.vue?vue&type=style&index=0&id=1d688ed5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d688ed5",
  null
  
)

export default component.exports